import { Header, RichTextDisplay } from "@datagame/ui";

import { ProgressBar } from "../../shared/ProgressBar";
import { QuickRankHand } from "../Destination";
import { QuickRankRenderableDestinations } from "../../../reducers/quickrank";
import { useQuickRankState } from "../../../hooks/quickrank/useQuickRankState";

import styles from "./Playground.module.scss";

const { RATED } = QuickRankRenderableDestinations;

export const Playground = () => {
  const [
    {
      configuration: {
        mode,
        question,
        numberOfHands,
        ratingQuestion,
        gameVisuals: { backgroundColor, backgroundImage, themeColor },
      },
      status: { round },
      cards: { [RATED]: rated },
    },
  ] = useQuickRankState();

  const isRatingMode = rated.length > 0;

  const backgroundColorStyle = !backgroundImage ? { backgroundColor } : undefined;

  const backgroundImageStyle = backgroundImage ? { backgroundImage: `url(${backgroundImage.url})` } : undefined;

  return (
    <div className={styles.playground} style={backgroundImageStyle}>
      <div className={styles.backgroundCircle} style={backgroundColorStyle} />
      <div className={styles.backgroundCircle} style={backgroundColorStyle} />
      <ProgressBar color={themeColor} currentStep={round - 1} steps={numberOfHands} className={styles.progressBar} />
      <Header variant="h5" className={styles.playgroundHeader}>
        {isRatingMode ? ratingQuestion : <RichTextDisplay value={question} />}
      </Header>

      <QuickRankHand mode={mode} isRating={isRatingMode} />
    </div>
  );
};
